export default "__VITE_ASSET__377d68f4__"